
import request from '@/utils/httpRequest'

export default class contractMaterAdjustService {
    getMateradjust(id) {
        return request({
            url: '/mater/materadjust/' + id,
            method: 'get',
            class:'mater'
        })
    }
}
